import { Injectable } from "@angular/core";

@Injectable()
export class User {
  id: number = 0;
  emailId: string = "";
  password: string = "";
  confPassword: string = "";
  loginStatus: boolean = false;
  firstName: string = "";
  lastName: string = "";
  phone: number = 0;
  terms: boolean = false;
  mobileNumber: number = 0;
  countryCode: string = "";
  countryISOCode: string = "";
  imageUrl: string = "";
  country: string = "";
  userName: string = "";
  packId: string = "";
  deviceId: string = "";
  token: string = "";
}



// WEBPACK FOOTER //
// ./src/app/shared/class/user.ts